var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_282_4334)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8125 30.4219C58.2872 28.8652 56.4669 27.6282 54.458 26.7831C52.4491 25.938 50.2919 25.5018 48.1125 25.5001H48.0506C45.8811 25.4945 43.7321 25.9193 41.728 26.75C39.7238 27.5807 37.9044 28.8007 36.375 30.3394L24.8644 42.0001C24.3071 42.5636 23.9955 43.3248 23.9976 44.1174C23.9997 44.9099 24.3154 45.6695 24.8756 46.2301L30.2494 51.6038C30.5275 51.8833 30.8583 52.1049 31.2226 52.2559C31.5869 52.4068 31.9775 52.4841 32.3719 52.4832H32.3887C32.7859 52.481 33.1787 52.4001 33.5444 52.2449C33.91 52.0898 34.2412 51.8636 34.5187 51.5794L45.9375 39.8794C46.4951 39.3274 47.2459 39.0145 48.0304 39.0072C48.815 38.9998 49.5715 39.2986 50.1394 39.8401C50.42 40.1127 50.6431 40.4388 50.7954 40.7992C50.9478 41.1596 51.0263 41.5469 51.0262 41.9382C51.03 42.3546 50.9517 42.7677 50.7956 43.1537C50.6396 43.5398 50.4089 43.8913 50.1169 44.1882L38.4375 55.4776C38.1522 55.7546 37.9249 56.0855 37.7687 56.4511C37.6124 56.8168 37.5305 57.2098 37.5275 57.6074C37.5245 58.0051 37.6006 58.3993 37.7514 58.7672C37.9021 59.1352 38.1245 59.4695 38.4056 59.7507L43.7794 65.1244C44.3396 65.6812 45.0962 65.9956 45.886 65.9998C46.6759 66.004 47.4357 65.6977 48.0019 65.1469L59.5894 53.8126C66.0487 47.3438 66.1481 36.8551 59.8125 30.4219ZM32.3719 49.4794L27 44.1076L31.4625 39.5851L36.81 44.9326L32.3719 49.4794ZM45.8981 63.0001L40.5206 57.6282L45.0919 53.2088L50.4375 58.5601L45.8981 63.0001ZM57.4781 51.6676L52.5825 56.4563L47.25 51.1276L52.2075 46.3332L52.2262 46.3163C52.8013 45.7366 53.2559 45.0488 53.5639 44.2925C53.8718 43.5363 54.0271 42.7266 54.0206 41.9101C54.0172 41.1211 53.8555 40.3408 53.545 39.6155C53.2346 38.8902 52.7816 38.2346 52.2131 37.6876C51.0739 36.6039 49.5569 36.0074 47.9847 36.0249C46.4125 36.0424 44.9092 36.6725 43.7944 37.7813L38.9044 42.7838L33.5625 37.4513L38.5031 32.4544C39.7538 31.1965 41.2417 30.1993 42.8806 29.5205C44.5195 28.8417 46.2767 28.4949 48.0506 28.5001H48.1012C49.8843 28.5016 51.6492 28.8586 53.2927 29.5501C54.9362 30.2416 56.4254 31.2538 57.6731 32.5276C62.8594 37.7907 62.7656 46.3838 57.4781 51.6713V51.6676Z",
    fill: "#FFFADD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_4334",
    x1: 0,
    y1: 45,
    x2: 90,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#776D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463C01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1);
export default __webpack_public_path__ + "static/media/c-1.f5baf3e2b653df57adf79f6e09908d73.svg";
export { ForwardRef as ReactComponent };